import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, MenuItem, FormControl, Select, Button, TextField, Checkbox, Snackbar, Alert, Radio, RadioGroup, FormControlLabel, FormLabel, FormGroup, Dialog, DialogActions, DialogTitle, Modal, Box} from '@mui/material';
import axios from 'axios'
import Pagination from "react-js-pagination";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { TbLoader } from 'react-icons/tb';
import mainPath from '../../../utils/path';
import { MdOutlineRefresh } from "react-icons/md";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

let date = new Date();
let year = date.getFullYear();
let month = date.getMonth();
month += 1;
if (month <= 9){
    month = "0" + month;
}
let day = date.getDate();
if (day <= 9){
    day = "0" + day;
}
let today = year + '-' + month + '-' + day;



const useStyles = makeStyles((theme)=>({
  orderListConfigBlock: {
    paddingBottom:'30px'
  },
  box: {
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  orderListConfigBlockH1:{
    padding:'40px 0 20px 70px',
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  datagridTop: {
    display: 'flex',
    borderTop: '1px solid #D3D3D3',
    borderBottom: '1px solid #D3D3D3',

    [theme.breakpoints.down(1025)]: {
      fontSize:'11px'
    }
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',

    [theme.breakpoints.down(1025)]: {
      display:'none',            
    }
  },
  mobileDatagridTopItem:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      display:'block',   
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #D3D3D3',
      borderTop: 'none',
      borderBottom: 'none',
    }
  },
  contBox: {
    display: 'flex',
    borderBottom: '1px solid #D3D3D3',
    [theme.breakpoints.down(1025)]: {
      fontSize:'11px'
    }
  },
  contBoxItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
    borderBottom: 'none',
    wordBreak:'break-all',

    [theme.breakpoints.down(1025)]: {
      display:'none',            
    }
  },
  mobileContBoxItem:{
    display:'none',

    [theme.breakpoints.down(1025)]: {
      borderTop: 'none',
      borderBottom: 'none',
      wordBreak:'break-all',
      textAlign:'center',
      alignItems: 'center',
      justifyContent: 'start',  
      display: 'flex',        
    }
  },
  checkBoxMain: {
    width: '7%',
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  textLeft: {
    width: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
  },
  textRight: {
    width: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
  },
  textMiddle: {
    width: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
    cursor: 'pointer'
  },
  numberMiddle: {
    width: '100%', 
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
  },
  imageText: {
    display: 'flex',
    alignItems: 'center'
  },

  innerClass: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    listStyle: 'none',
    padding: 0,
  },
  itemClass: {
      minWidth: '30px',
      border: '1px solid #e2e2e2',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1rem',
  },
  itemClassFirst: {
      borderRadius: '15px 0 0 15px',
  },
  itemClassLast: {
      borderRadius: '0 15px 15px 0',
  },
  linkClass: {
      textDecoration: 'none',
      color: '#383A3F',
      fontSize: '1rem',
  },
  activeClass: {
      backgroundColor: '#383A3F'
  },
  activeLinkClass: {
      color: 'white',
  },
  btnDiv:{
    display:'flex',
    justifyContent:'end',
    marginTop:'30px'
  },
  formDiv:{
    display:'flex',
    marginRight:'10px'
  },
  bottomDiv:{
    paddingBottom:'30px',
    display:'flex',
    alignItems:'center',
    
    [theme.breakpoints.down(1025)]: {
      display:'none',     
    }
  },
  formBox:{

  },
  RightDiv:{
    margin:'0 0 0 20px',
    display:'flex',
    alignItems:'center',
  },
  sumDiv:{
    paddingTop:'50px',
    fontSize:'20px',
    fontWeight:'600',
  },
  formControlDiv:{
    padding:'10px 0',

    [theme.breakpoints.down(1025)]: {
      display:'none',     
    }
  },
  formLabelSpan:{
    display:'block',
    fontSize:'16px',
    color:'rgba(0, 0, 0, 0.6)',
  },
  orderConditionDiv:{
    display:'flex',
    alignItems:'center',
    paddingBottom:'20px',
  },
  bottomDiv:{
    paddingBottom:'30px',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      display:'none',     
    }
  },
  formBox:{
    marginRight:'10px'
  },
  modalBox: {
    width: 500,
    height: 500,
    backgroundColor: '#fff',
    borderRadius: 10,
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalDiv:{
    display:'flex',
    alignItems: 'center',
    borderBottom:'1px solid #ccc'
  },
  textDivSpan:{
    fontWeight:'600'
  },
  textMiddleDiv:{
    padding:'5px 0'
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
  navibox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems:'center'
  },
  naviArrow: {
    marginTop: 13,
    cursor: 'pointer',
    border: '1px solid gray',
    padding: 5
  }
}));



const OrderListConfig = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const checkBox = true
  const sendCost = parseInt(useSelector(state => state.config.shopDefaultConfig.de_send_cost_list));
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)

  const row = [
    {name: '주문번호', width: '12%'},
    {name: '주문자', width: '7%'},
    {name: '지역', width: '7%'},
    {name: '상호', width: '15%'},
    {name: '주문금액', width: '7%'},
    {name: '포인트', width: '7%'},
    {name: '희망배송일', width: '7%'},
    {name: '담당자', width: '7%'},
    {name: '순서번호', width: '8%'},
    {name: '보기', width: '8%'},
    {name: '상태', width: '8%'}, 10
  ];

  const mobileRow = [
    {name: '주문자', width: '30%'}, // 1
    {name: '희망배송일', width: '50%'},  // 6
    {name: '담당자', width: '30%'}, // 7
    {name: '순서번호', width: '50%'}, // 8
    {name: '보기', width: '50%'},  // 10
  ];

  const [data, setData] = useState([])

  const [page, setPage] = useState(1);
  const [orderStatus, setOrderStatus] = useState(0);
  const [etcSelectList, setEtcSelectList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [pasings, setPasings] = useState(0);
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [search, setSearch] = useState(false);
  const [searchType, setSearchType] = useState(0);
  const [keyword, setKeyword] = useState('');

  const [priceSum, setPriceSum] = useState(0);
  const [pointSum, setPointSum] = useState(0);

  const [picList, setPicList] = useState([]) 
  const [picNumList, setPicNumList] = useState([])

  const [dialog, setDialog] = useState('');

  const [modalOpen, setModalOpen] = useState(false)

  const [modalData, setModalData] = useState([]) 

  const [loading, setLoading] = useState(false)

  const [allState, setAllState] = useState('주문')

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setPage(1)
      setPasings(0)
      setEtcSelectList([])
      setStartDate("")
      setEndDate("")
      setSearch(false)
      setSearchType(0)
      setKeyword('')
      setPriceSum(0)
      setPointSum(0)
      setPicList([])
      setModalData([])
    }
  }, [])


  const getItems = async() => {
    let staDay = ''
    let endDay = ''

    if (startDate === "") { 
      staDay = "1111-11-11" 
    }else{
      staDay = startDate
    } 
    
    if (endDate === "") { 
      endDay = "9999-12-30" 
    } else{
      endDay = endDate
    } 

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/orderListReport/', 
                    {page: page, order_status: orderStatus, etc_select_list: etcSelectList, start_date: staDay, end_date: endDay } )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_id'], mbId: item['mb_id'], data: item['od_id'], type: 'textModal'},
        {id: item['od_id'], mbId: item['mb_id'], mbNo: item['mb_no'], data: item['od_name'], type: 'textMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['mb_region'], type: 'textLeft'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['mb_storename'], type: 'textLeftStr', search: item['od_name']},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_cart_price'], type: 'numberMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_receipt_point'], type: 'numberMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_hope_date'], type: 'textLeft'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['pic_id'], type: 'textRight'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_num'], type: 'numberfield'},
        {id: item['od_id'], mbId: item['mb_id'], data: ['보기'], type: 'button'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_status'], type: 'select2'},
      ]], []))

      setPicNumList(res.data.picList.reduce((res, itm) => [...res, itm.pic_id] ,[]))
      
      setPicList(res.data.picList)
      setPasings(res.data.itemCount)

      setPriceSum(res.data.result.reduce((result, item) => result + item['od_cart_price'], 0))
      setPointSum(res.data.result.reduce((result, item) => result + item['od_receipt_point'], 0))

      setChecks([])
      setAllChecked(false)
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }


  const searchItem = async() => {
    let staDay = ''
    let endDay = ''

    if (startDate === "") { 
      staDay = "1111-11-11" 
    }else{
      staDay = startDate
    } 
    
    if (endDate === "") { 
      endDay = "9999-12-30" 
    } else{
      endDay = endDate
    } 
    
    setSearch(true)

    try {
      setLoading(true)
      const res = await axios.post('/api/adm/orderSearch/', 
      {
        page: page, 
        search_type: searchType, 
        keyword: keyword,
        start_date: staDay, 
        end_date: endDay,
        order_status: orderStatus,  
      } 
      )

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
      setData(res.data.result.reduce((result, item) => [
        ...result, 
        [{id: item['od_id'], mbId: item['mb_id'], data: item['od_id'], type: 'textModal'},
        {id: item['od_id'], mbId: item['mb_id'], mbNo: item['mb_no'], data: item['od_name'], type: 'textMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['mb_region'], type: 'textLeft'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['mb_storename'], type: 'textLeftStr', search: item['od_name']},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_cart_price'], type: 'numberMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_receipt_point'], type: 'numberMiddle'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_hope_date'], type: 'textLeft'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['pic_id'], type: 'textRight'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_num'], type: 'numberfield'},
        {id: item['od_id'], mbId: item['mb_id'], data: ['보기'], type: 'button'},
        {id: item['od_id'], mbId: item['mb_id'], data: item['od_status'], type: 'select2'},
      ]
      ], []))

      setPicNumList(res.data.picList.reduce((res, itm) => [...res, itm.pic_id] ,[]))
      
      setPicList(res.data.picList)
      setPasings(res.data.itemCount)

      setPriceSum(res.data.result.reduce((result, item) => result + item['od_cart_price'], 0))
      setPointSum(res.data.result.reduce((result, item) => result + item['od_receipt_point'], 0))

      setChecks([])
      setAllChecked(false)
      setLoading(false)
  
    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }

    if (keyword === ''){
      setSearch(false)
    }

  }

  useEffect(() => {

    if(search) {
      searchItem()
    } else{
      getItems()
    }

    setChecks([])
    setAllChecked(false)
    
  }, [page])

  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item[0].id));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])

  const handlePageChange = (page) => {
    setPage(page);
  };

  const editSelItems = async() => {
    let odList = []
    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].data === arrItem){
          odList.push({
            od_id: dataItem[0].data, 
            od_num: dataItem[8].data, 
            od_status: dataItem[10].data, 
            mb_id: dataItem[0].mbId, 
            od_send_cost: sendCost,
          })
        } 
      })
    })


    try {
      const res = await axios.post('/api/adm/orderNumPicSelectEdit/', {od_list: odList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      setSearch(false)
      getItems()
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const getModalItm = async(odId) => {

    try {
      const res = await axios.post('/api/adm/getOrderListItm/', {od_id: odId} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setModalData(res.data.result)
      setModalOpen(true)
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };


  return (
    <div className={classes.orderListConfigBlock}>
      <h1 className={classes.orderListConfigBlockH1}>
        주문내역       
        <div
          onClick={() => {
            setPage(1)
            setPasings(0)
            setEtcSelectList([])
            setStartDate("")
            setEndDate("")
            setSearch(false)
            setSearchType(0)
            setKeyword('')
            setPriceSum(0)
            setPointSum(0)
            setPicList([])
            setModalData([])
            getItems()
          }}
        style={{cursor:'pointer'}}
      >
        <MdOutlineRefresh/>
      </div>
      </h1>

      <div className={classes.box}>
      <div>
        <div className={classes.formControlDiv}>           
          <FormControl>
            <FormLabel 
              className={classes.formLabelSpan}
              style={{     
                fontFamily:[
                'Noto Sans KR'
                ],
              }}
            >
              주문상태
            </FormLabel>
            <RadioGroup defaultValue={0} row>
              <FormControlLabel value={0} onChange={() => setOrderStatus(0)} control={<Radio />} label="전체" />
              <FormControlLabel value={1} onChange={() => setOrderStatus(1)} control={<Radio />} label="주문" />
              <FormControlLabel value={5} onChange={() => setOrderStatus(5)} control={<Radio />} label="완료" />
              <FormControlLabel value={6} onChange={() => setOrderStatus(6)} control={<Radio />} label="전체취소" />
            </RadioGroup>
          </FormControl>
        </div>
        
        <div className={classes.formControlDiv}>
          <span className={classes.formLabelSpan}>주문일자</span>
          <div className={classes.orderConditionDiv}>
            <Button 
              variant="outlined"
              style={{ marginRight:'20px'}}
              onClick={() => {
                setStartDate(today)
                setEndDate(today)
              }}
            >
              오늘
            </Button>
            <Button 
              variant="outlined"
              style={{ marginRight:'20px'}}
              onClick={() => {
                let currentDay = new Date();
                let currentDay2 = new Date(currentDay)
                currentDay2.setDate(currentDay.getDate() - 1)

                let yearY = currentDay2.getFullYear();
                let monthY = currentDay2.getMonth();
                monthY += 1;
                if (monthY <= 9){
                    monthY = "0" + monthY;
                }
                let dayY = currentDay2.getDate();
                if (dayY <= 9){
                    dayY = "0" + dayY;
                }
                let yesterday = yearY + '-' + monthY + '-' + dayY;

                setStartDate(yesterday)
                setEndDate(yesterday)
              }}
            >
              어제
            </Button>
            <Button 
              variant="outlined"
              style={{ marginRight:'20px'}}
              onClick={() => {
                let currentDay = new Date();  
                let theYear = currentDay.getFullYear();
                let theMonth = currentDay.getMonth();
                let theDate  = currentDay.getDate();
                let theDayOfWeek = currentDay.getDay();
                
                let thisWeek = [];
                
                for(let i=0; i<7; i++) {
                  let resultDay = new Date(theYear, theMonth, theDate + (i - theDayOfWeek));
                  let yyyy = resultDay.getFullYear();
                  let mm = Number(resultDay.getMonth()) + 1;
                  let dd = resultDay.getDate();
                
                  mm = String(mm).length === 1 ? '0' + mm : mm;
                  dd = String(dd).length === 1 ? '0' + dd : dd;
                
                  thisWeek[i] = yyyy + '-' + mm + '-' + dd;
                }
    
                setStartDate(thisWeek[0])
                // setEndDate(thisWeek[thisWeek.length - 1])
                setEndDate(today)
              }}
              >
                이번주
            </Button>
            <Button 
              variant="outlined"
              style={{ marginRight:'20px'}}
              onClick={() => {
                let currentDay = new Date();  
                let theYear = currentDay.getFullYear();
                let theMonth = currentDay.getMonth() ;
            
                if(theMonth < 1) {
                  theYear -= 1
                  theMonth = 12
                } 
            
                let mm = String(theMonth).length === 1 ? '0' + theMonth : theMonth;
    
                setStartDate(`${theYear}-${mm}-01`)
                setEndDate(`${theYear}-${mm}-31`)
              }}
            >
              지난달
            </Button>
            <Button 
              variant="outlined"
              style={{ marginRight:'20px'}}
              onClick={() => {
                setStartDate("")
                setEndDate("")
              }}
            >
              전체
            </Button>
            <TextField
              type="date"
              label="시작일"
              value={startDate}
              style={{ marginRight:'20px'}}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setStartDate(e.target.value)
              }}
            />
            <TextField
              type="date"
              label="종료일"
              value={endDate}
              style={{ marginRight:'20px'}}
              sx={{ width: 220 }}
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(e) => {
                setEndDate(e.target.value)
              }}
            />            
            <Button 
              variant="outlined"
              onClick={() => {
                const today1 = new Date(today);
                const day1 = new Date(startDate);
                const day2 = new Date(endDate);
    
                if(day2 > today1) return setDialog('현재일보다 선택일이 더 큽니다!')
                if(day1 > day2) return setDialog('시작일이 종료일보다 더 큽니다!')
                setPage(1)
                setSearch(false)
                getItems()
              }}
            >
              검색
            </Button>
          </div>
        </div>    
      </div>
  
  
  
  
  
        <div className={classes.bottomDiv}>
          <FormControl 
            size="small"
            className={ classes.formBox}
          >
            <Select
              value={searchType}
              onChange={(e) => {
                setKeyword('')
                setSearchType(e.target.value)
              }}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >
              <MenuItem value={2}>주문자</MenuItem>
              <MenuItem value={9}>담당자</MenuItem>
              <MenuItem value={1}>회원ID</MenuItem>
              <MenuItem value={0}>주문번호</MenuItem>
            </Select>
          </FormControl>
          <div className={ classes.RightDiv}>
            {searchType !== 9 ? 
            (<TextField 
              label="검색어를 입력해주세요." 
              variant="standard" 
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if(e.key === 'Enter') {
                  if(searchType === 9 && typeof(keyword) === 'string') return;
    
                  setPage(1)
                  searchItem()
                }
              }}
            />) : 
            (
              <FormControl size="small">
                <Select
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {picList.length > 0 &&
                      picList.map((item) => (
                        <MenuItem key={item['pic_id']} value={item['pic_id']}>{item['pic_name']}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            )
            }
            <Button 
              variant="outlined"
              onClick={() => {
                if(searchType === 9 && typeof(keyword) === 'string') return;
    
                setPage(1)
                searchItem()
              }}
            >
              검색
            </Button>
          </div>
        </div>

        <div className={classes.bottomDiv}>
          <FormControl size="small">
            <FormLabel 
              className={classes.formLabelSpan}
              style={{     
                fontFamily:[
                'Noto Sans KR'
                ],
                marginBottom: 5
              }}
            >
              주문상태 전체 변경
            </FormLabel>
            <Select
              value={allState}
              onChange={(e) => {
                setAllState(e.target.value)
              }}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
            >
              <MenuItem value={'주문'}>주문</MenuItem>
              <MenuItem value={'완료'}>완료</MenuItem>
              <MenuItem value={'취소'}>취소</MenuItem>
            </Select>
          </FormControl>
          <Button 
            variant="outlined" 
            style={{
              marginTop: 15,
              marginLeft: 5
            }}
            onClick={async() => {
              let allCheckList = []

              let dataArr = [...data]
              let odList = []

              dataArr.forEach((itmArr, index) => {
                let itm = [...itmArr]
                itm[10].data = allState
                dataArr[index] = itm
              })

              dataArr.forEach(item => allCheckList.push(item[0].id));

              allCheckList.forEach((arrItem) => {
                dataArr.forEach((dataItem) => {
                  if(dataItem[0].data === arrItem){
                    odList.push({
                      od_id: dataItem[0].data, 
                      od_num: dataItem[8].data, 
                      od_status: dataItem[10].data, 
                      mb_id: dataItem[0].mbId, 
                      od_send_cost: sendCost,
                    })
                  } 
                })
              })
          
          
              try {
                const res = await axios.post('/api/adm/orderNumPicSelectEdit/', {od_list: odList} )
          
                if(res.data.success === false){
                  setErrSnack(true)
                  console.log('실패')
                  return ;
                }
          
                setSuccSnack(true)
                setChecks([])
                setAllChecked(false)
                setSearch(false)
                getItems()
                
              } catch (e) {
                setErrSnack(true)
                console.log(e)
              }


            }}
          >
            전체 변경
          </Button>
        </div>


        <div 
          className={classes.btnDiv} 
          style={{marginBottom: 5}}
        >
            <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
              선택수정
            </Button>
        </div>
        <div className={classes.datagridBox}>
          <div className={classes.datagridTop}>
            {checkBox && (
                <div className={classes.checkBoxMain}>
                  <Checkbox 
                    checked={allChecked}
                    onChange={e => setAllChecked(e.target.checked)}
                  />
                </div>
            )}
            {row.map((item, index) => (
                      <div key={index} className={classes.datagridTopItem} style={{width: item.width}}>
                        {item.name}
                      </div>
            ))}

            {mobileRow.map((mitem, index) => (
                      <div key={index} className={classes.mobileDatagridTopItem} style={{width: mitem.width}}>
                        {mitem.name}
                      </div>
            ))}
          </div>
  
          { loading ? (
            <div className={classes.load}>
              <TbLoader className={classes.loadingIcon}/>
            </div>
          ) :
          (data.length > 0 && picList.length > 0) &&data.map((dataItem, dataIndex) => {
            return(
                    <div 
                      key={dataIndex} 
                      className={classes.contBox}
                      style={{
                        backgroundColor: dataIndex % 2 === 0 && '#F2F2F2'
                      }}
                    >
                        {checkBox && (
                          <div className={classes.checkBoxMain}>
                            <Checkbox
                              checked={checks.includes(dataItem[0].id)}
                              onChange={() => !checks.includes(dataItem[0].id) ?
                                              setChecks([...checks, dataItem[0].id]) : 
                                              setChecks([...checks.filter((item) => item !==  dataItem[0].id)])
                                        }
                            />
                          </div>
                        )}
  
                        {dataItem.map((item, index) => {
                          return(
                                <div 
                                  key={index} 
                                  className={classes.contBoxItem} 
                                  style={{
                                    width: row[index].width,
                                  }}
                                >
                                  {item.type === 'textLeft' && (
                                    <h3 className={classes.textLeft}>{item.data}</h3>
                                  )}
                                  {item.type === 'textLeftStr' && (
                                    <h3 
                                      className={classes.textLeft}
                                      style={{cursor: 'pointer'}}
                                      onClick={async() => {
                                        if(page === 1) {
                                          try {
                                            setLoading(true)
                                            setSearch(true)
                                            setSearchType(1)
                                            setKeyword(item.mbId)
                                            const res = await axios.post('/api/adm/orderSearch/', {
                                              page: 1, 
                                              search_type: 1, 
                                              keyword: item.mbId,
                                              start_date: "1111-11-11" , 
                                              end_date: "9999-12-30" ,
                                              order_status: 0,  
                                            } )
                                      
                                            if(res.data.success === false) {
                                              setErrSnack(true)
                                              return ;
                                            }
                                            setData(res.data.result.reduce((result, item) => [
                                              ...result, 
                                              [{id: item['od_id'], mbId: item['mb_id'], data: item['od_id'], type: 'textModal'},
                                              {id: item['od_id'], mbId: item['mb_id'], mbNo: item['mb_no'], data: item['od_name'], type: 'textMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['mb_region'], type: 'textLeft'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['mb_storename'], type: 'textLeftStr', search: item['od_name']},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_cart_price'], type: 'numberMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_receipt_point'], type: 'numberMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_hope_date'], type: 'textLeft'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['pic_id'], type: 'textRight'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_num'], type: 'numberfield'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: ['보기'], type: 'button'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_status'], type: 'select2'},
                                            ]
                                            ], []))
                                            
                                            setPicList(res.data.picList)
                                            setPasings(res.data.itemCount)
                                      
                                            setPriceSum(res.data.result.reduce((result, item) => result + item['od_cart_price'], 0))
                                            setPointSum(res.data.result.reduce((result, item) => result + item['od_receipt_point'], 0))
                                      
                                            setChecks([])
                                            setAllChecked(false)
                                            setLoading(false)
                                        
                                          } catch (e) {
                                            setErrSnack(true)
                                            setLoading(false)
                                            console.log(e)
                                          }
                                        } else {
                                          setSearch(true)
                                          setSearchType(1)
                                          setKeyword(item.mbId)
                                          setPage(1)
                                        }

                                      }}
                                    >
                                      {item.data}
                                    </h3>
                                  )}
                                  {item.type === 'textModal' && (
                                    <h3 
                                      className={classes.textLeft}
                                      style={{cursor: 'pointer'}}
                                      onClick={() => getModalItm(item.data)}
                                    >
                                      {item.data}
                                    </h3>
                                  )}
                                  {item.type === 'textRight' && ( //관리자
                                    <h3 
                                      className={classes.textRight}
                                      style={{cursor: 'pointer'}}
                                      onClick={async() => {
                                        if(page === 1) {
                                          try {
                                            setLoading(true)
                                            setSearch(true)
                                            setSearchType(9)
                                            setKeyword(item.data)
                                            const res = await axios.post('/api/adm/orderSearch/', {
                                              page: 1, 
                                              search_type: 9, 
                                              keyword: item.data,
                                              start_date: "1111-11-11" , 
                                              end_date: "9999-12-30" ,
                                              order_status: 0,  
                                            } )
                                      
                                            if(res.data.success === false) {
                                              setErrSnack(true)
                                              return ;
                                            }
                                            setData(res.data.result.reduce((result, item) => [
                                              ...result, 
                                              [{id: item['od_id'], mbId: item['mb_id'], data: item['od_id'], type: 'textModal'},
                                              {id: item['od_id'], mbId: item['mb_id'], mbNo: item['mb_no'], data: item['od_name'], type: 'textMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['mb_region'], type: 'textLeft'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['mb_storename'], type: 'textLeftStr', search: item['od_name']},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_cart_price'], type: 'numberMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_receipt_point'], type: 'numberMiddle'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_hope_date'], type: 'textLeft'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['pic_id'], type: 'textRight'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_num'], type: 'numberfield'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: ['보기'], type: 'button'},
                                              {id: item['od_id'], mbId: item['mb_id'], data: item['od_status'], type: 'select2'},
                                            ]
                                            ], []))
                                            
                                            setPicList(res.data.picList)
                                            setPasings(res.data.itemCount)
                                      
                                            setPriceSum(res.data.result.reduce((result, item) => result + item['od_cart_price'], 0))
                                            setPointSum(res.data.result.reduce((result, item) => result + item['od_receipt_point'], 0))
                                      
                                            setChecks([])
                                            setAllChecked(false)
                                            setLoading(false)
                                        
                                          } catch (e) {
                                            setErrSnack(true)
                                            setLoading(false)
                                            console.log(e)
                                          }
                                        } else {
                                          setSearch(true)
                                          setSearchType(9)
                                          setKeyword(item.data)
                                          setPage(1)
                                        }

                                      }}
                                    >
                                      {picNumList.includes(item.data) ? picList.find(itm => itm['pic_id'] === item.data)['pic_name'] : '-'}
                                    </h3>
                                  )}
                                  {item.type === 'textMiddle' && (
                                    <h3 
                                      className={classes.textMiddle}
                                      onClick={() => {
                                        navigate("/DashboardMain/memberEdit", {
                                          state: { mb_no: item.mbNo }
                                        });
                                      }}
                                    >
                                      {item.data}
                                    </h3>
                                  )}
                                  {item.type === 'numberMiddle' && (
                                    <h3 className={classes.numberMiddle}>
                                      {item.data && item.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    </h3>
                                  )}
                                  {item.type === 'imageText' && (
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5}}
                                        src={item.img} 
                                      />
                                      <h3>{item.data}</h3>
                                    </div>
                                  )}
                                  {item.type === 'textfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}
                                  {item.type === 'numberfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={item.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      type='number'
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: parseInt(e.target.value)}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}
                                  {item.type === 'button' && 
                                    (
                                      <div style={{width: '100%', height: '100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        {item.data.map((btnItm, btnIdx) => (
                                        <Button 
                                          key={btnIdx} 
                                          variant="text"
                                          onClick={() => {
                                            navigate("/DashboardMain/orderEdit", {
                                              state: { od_id: item.id }
                                            });
                                          }}
                                        >
                                          {btnItm}
                                        </Button>
                                        ))}
                                      </div>
                                    )
                                  }
                                  {item.type === 'select' && (
                                    <FormControl sx={{ m: 1, minWidth: '100%' }} size="small">
                                      <Select
                                        labelId="select-small"
                                        id="select-small"
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        value={item.data}
                                        onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)
                                        }}
                                      >
                                        {picList.map((value) => <MenuItem key={value['pic_id']} value={value['pic_id']}>{value['pic_name']}</MenuItem>)}
                                      
                                      </Select>
                                    </FormControl>
                                  )}
                                  {item.type === 'select2' && (
                                    <FormControl 
                                      sx={{ m: 1, minWidth: '100%', backgroundColor: dataItem[10].data === '취소' ? '#FFD9E4' : dataItem[10].data === '완료' ? '#ACFFEF' : '#FFFFFF' }} 
                                      size="small"
                                    >
                                      <Select
                                        labelId="select-small"
                                        id="select-small"
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        value={item.data}
                                        onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)
                                        }}
                                      >
                                        <MenuItem value={'주문'}>주문</MenuItem>
                                        <MenuItem value={'완료'}>완료</MenuItem>
                                        <MenuItem value={'취소'}>취소</MenuItem>
                                      
                                      </Select>
                                    </FormControl>
                                  )}                                  
  
                                </div>
                        )})}

                        {dataItem.map((mitem, index) => {
                          if( index !==1 && index !==6 && index !== 7 && index !== 8 && index !== 10) return;
                          let param = 0
                          if (index === 0) { param = 0}
                          if (index === 6) { param = 1}
                          if (index === 7) { param = 2}
                          if (index === 8) { param = 3}
                          if (index === 10) { param = 4}

                          return(
                                <div 
                                  key={index} 
                                  className={classes.mobileContBoxItem}
                                  style={{
                                    width: mobileRow[param].width,
                                    // backgroundColor: dataItem[10].data === '취소' ? '#FFDEE9' : dataItem[10].data === '완료' ? '#87F5F5' : '#FFFFFF'
                                  }}
                                >
                                  <div>
                                  {mitem.type === 'textModal' && (
                                    <h3 className={classes.textLeft}>{mitem.data}</h3>
                                  )}
                                  {mitem.type === 'textLeft' && (
                                    <h3 
                                      className={classes.textLeft}
                                    >
                                      {mitem.data}
                                    </h3>
                                  )}
                                  {mitem.type === 'textMiddle' && (
                                    <h3 
                                      className={classes.textMiddle}
                                      onClick={() => {
                                        navigate("/DashboardMain/memberEdit", {
                                          state: { mb_no: mitem.mbNo }
                                        });
                                      }}
                                    >
                                      {mitem.data}
                                    </h3>
                                  )}
                                  {mitem.type === 'numberMiddle' && (
                                    <h3 className={classes.textMiddle}>{mitem.data && mitem.data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</h3>
                                  )}
                                  {mitem.type === 'imageText' && (
                                    <div className={classes.imageText}>
                                      <img
                                        style={{width: 50, height: 50, marginRight: 5}}
                                        src={mitem.img} 
                                      />
                                      <h3>{mitem.data}</h3>
                                    </div>
                                  )}
                                  {mitem.type === 'textfield' && (
                                    <TextField
                                      hiddenLabel
                                      id="filled-hidden-label-small"
                                      value={mitem.data}
                                      variant="filled"
                                      size="small"
                                      fullWidth
                                      onChange={(e) => {
                                          let dataList = [...data]
                                          let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                          dataList[dataIndex][index] = arrayItm
                                          setData(dataList)}
                                        }
                                    />
                                  )}
                                 
                                  {mitem.type === 'textRight' && ( //관리자
                                    <h3 
                                      className={classes.textRight}
                                      style={{cursor: 'pointer'}}
                                      onClick={async() => {
                                        if(page === 1) {
                                          try {
                                            setLoading(true)
                                            setSearch(true)
                                            setSearchType(9)
                                            setKeyword(mitem.data)
                                            const res = await axios.post('/api/adm/orderSearch/', {
                                              page: 1, 
                                              search_type: 9, 
                                              keyword: mitem.data,
                                              start_date: "1111-11-11" , 
                                              end_date: "9999-12-30" ,
                                              order_status: 0,  
                                            } )
                                      
                                            if(res.data.success === false) {
                                              setErrSnack(true)
                                              return ;
                                            }
                                            setData(res.data.result.reduce((result, mitem) => [
                                              ...result, 
                                              [{id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_id'], type: 'textModal'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], mbNo: mitem['mb_no'], data: mitem['od_name'], type: 'textMiddle'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['mb_region'], type: 'textLeft'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['mb_storename'], type: 'textLeftStr', search: mitem['od_name']},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_cart_price'], type: 'numberMiddle'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_receipt_point'], type: 'numberMiddle'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_hope_date'], type: 'textLeft'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['pic_id'], type: 'textRight'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_num'], type: 'numberfield'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: ['보기'], type: 'button'},
                                              {id: mitem['od_id'], mbId: mitem['mb_id'], data: mitem['od_status'], type: 'select2'},
                                            ]
                                            ], []))
                                            
                                            setPicList(res.data.picList)
                                            setPasings(res.data.itemCount)
                                      
                                            setPriceSum(res.data.result.reduce((result, item) => result + item['od_cart_price'], 0))
                                            setPointSum(res.data.result.reduce((result, item) => result + item['od_receipt_point'], 0))
                                      
                                            setChecks([])
                                            setAllChecked(false)
                                            setLoading(false)
                                        
                                          } catch (e) {
                                            setErrSnack(true)
                                            setLoading(false)
                                            console.log(e)
                                          }
                                        } else {
                                          setSearch(true)
                                          setSearchType(9)
                                          setKeyword(mitem.data)
                                          setPage(1)
                                        }

                                      }}
                                    >
                                      {picNumList.includes(mitem.data) ? picList.find(itm => itm['pic_id'] === mitem.data)['pic_name'] : '-'}
                                    </h3>
                                  )}
                                  </div>
                                  <div>
                                    {mitem.type === 'numberfield' && (
                                      <TextField
                                        hiddenLabel
                                        id="filled-hidden-label-small"
                                        value={mitem.data}
                                        variant="filled"
                                        size="small"
                                        fullWidth
                                        type='number'
                                        style={{ width: 60}}
                                        onChange={(e) => {
                                            let dataList = [...data]
                                            let arrayItm = {...dataList[dataIndex][index], data: parseInt(e.target.value)}
                                            dataList[dataIndex][index] = arrayItm
                                            setData(dataList)}
                                          }
                                      />
                                    )}
                                    {mitem.type === 'select2' && (
                                      <FormControl 
                                        sx={{ m: 1, width: 70,  backgroundColor: dataItem[10].data === '취소' ? '#FFD9E4' : dataItem[10].data === '완료' ? '#ACFFEF' : '#FFFFFF' }} 
                                        size="small"
                                      >
                                        <Select
                                          labelId="select-small"
                                          id="select-small"
                                          inputProps={{ 'aria-label': 'Without label' }}
                                          value={mitem.data}
                                          onChange={(e) => {
                                            let dataList = [...data]
                                            let arrayItm = {...dataList[dataIndex][index], data: e.target.value}
                                            dataList[dataIndex][index] = arrayItm
                                            setData(dataList)
                                          }}
                                        >
                                          <MenuItem value={'주문'}>주문</MenuItem>
                                          <MenuItem value={'완료'}>완료</MenuItem>
                                          <MenuItem value={'취소'}>취소</MenuItem>
                                        
                                        </Select>
                                      </FormControl>
                                    )}                          
                                  </div>
                                           
  
                                </div>
                        )})}
                    </div>
          )})}
  
        </div>
        <div className={classes.btnDiv}>
          <Button variant="outlined" onClick={() => checks.length > 0 && editSelItems()}>
            선택수정
          </Button>
        </div>
      </div>

      <div className={classes.box}>
      <div className={classes.navibox}>
          <AiOutlineDoubleLeft 
            onClick={() => setPage(1)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineLeft 
            onClick={() => setPage(page-5 <= 0 ? 1 : page-5)}
            className={classes.naviArrow}
            size="24"
          />
          <Pagination
              activePage={page}
              itemsCountPerPage={15}
              totalItemsCount={pasings}
              pageRangeDisplayed={5}
              prevPageText={"‹"}
              nextPageText={"›"}
              onChange={handlePageChange}
              className={classes.navi}
              innerClass={classes.innerClass}    //안에?
              itemClass={classes.itemClass}      //아이템들?
              itemClassFirst={classes.itemClassFirst}    //first?
              itemClassLast={classes.itemClassLast}     // last
              linkClass={classes.linkClass}        // 아이템 링크
              activeClass={classes.activeClass}        // 현재페이지
              activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
              hideDisabled
              hideNavigation
              hideFirstLastPages
          />
          <AiOutlineRight 
            onClick={() => setPage(page+5 > Math.ceil(pasings/15) ? Math.ceil(pasings/15) : page+5)}
            className={classes.naviArrow}
            size="24"
          />
          <AiOutlineDoubleRight 
            onClick={() => setPage(Math.ceil(pasings/15))}
            className={classes.naviArrow}
            size="24"
          />
        </div>
  

  
  
  

      </div>

      <div className={classes.box}>
        <div className={classes.sumDiv}>
          <div>주문금액 합계: {priceSum && priceSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
          <div>포인트 합계: {pointSum && pointSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</div>
        </div>
      </div>  






      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
      <Dialog
        open={dialog === '' ? false : true}
        onClose={() => setDialog('')}
      >
        <DialogTitle id="alert-dialog-title">
          {dialog}
        </DialogTitle>
        <DialogActions>
          <Button 
            onClick={() => setDialog('')} 
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={classes.modal}
      >
        <Box
          className={classes.modalBox}
        >
          <div style={{width : '95%', height: '90%', overflowY: 'scroll'}}>
            <h3>총 단수 : {modalData.length > 0 && modalData.reduce((result, itm) => result + itm['ct_qty'], 0)}</h3>
            {modalData.length > 0 && modalData.map((item, index) =>(
              <div key={index} className={classes.modalDiv}>
                <img
                  style={{width: 100, height: 100, margin:'10px 10px 10px 0' }}
                  src={`${mainPath}/media/data/item/${item['it_img1']}`} 
                />
                <div className={classes.textDiv}>
                  <div>
                    <span className={classes.textDivSpan}>제품명 :</span> 
                    {item['it_name']}
                  </div>
                  <div className={classes.textMiddleDiv}>
                    <span className={classes.textDivSpan}>수량 :</span> 
                    {item['ct_qty']}
                  </div>
                  <div>
                    <span className={classes.textDivSpan}>가격 : </span>
                    {item['ct_price']}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <Button
            onClick={() => setModalOpen(false)} 
            style={{ background:'#007235', color:'#fff'}}
          >
            확인
          </Button>


        </Box>
      </Modal>

    </div>
  )
}

export default OrderListConfig
